import { rootApi } from "..";
import { hrService } from "../../../Api/Services/HRService";
import { reportService } from "../../../Api/Services/ReportService";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

export const reportZoneEndpoints = [
  {
    name: "employeeSalaryReportList",
    type: "query",
    serviceFn: ({
      employeeId,
      endDate,
      jobType,
      startDate,
    }: {
      startDate?: string;
      endDate?: string;
      employeeId?: string;
      jobType?: string;
    }) =>
      reportService.employeeSalaryReport({
        startDate,
        endDate,
        employeeId,
        jobType,
      }),
    tagType: "EmployeeSalaryReportList",
  },
  {
    name: "employeesConveyanceReportList",
    type: "query",
    serviceFn: ({
      employeeId,
      endDate,
      startDate,
      page,
      size,
      jobType,
    }: {
      startDate?: string;
      endDate?: string;
      employeeId?: string;
      page?: number;
      size?: number;
      jobType?: string;
    }) =>
      reportService.conveyanceReport({
        employeeId,
        endDate,
        startDate,
        page,
        size,
        jobType,
      }),
  },

  {
    name: "employeeLeaveReportList",
    type: "query",
    serviceFn: ({
      startDate,
      endDate,
      employeeId,
      jobType,
    }: {
      startDate: string;
      endDate: string;
      employeeId?: Array<number>;
      jobType?: string;
    }) =>
      reportService.employeeLeaveReport({
        startDate,
        endDate,
        employeeId,
        jobType,
      }),
  },

  {
    name: "employeeAttendanceCompoffSummaryList",
    type: "query",
    serviceFn: ({
      startDate,
      endDate,
      employeeId,
      jobType,
      page,
      size,
    }: {
      startDate: string;
      endDate: string;
      employeeId?: Array<number>;
      jobType?: string;
      page?: number;
      size?: number;
    }) =>
      reportService.employeeAttendanceCompoffSummary({
        startDate,
        endDate,
        employeeId,
        jobType,
        page,
        size,
      }),
  },

  {
    name: "employeeMonthlyWiseReportList",
    type: "query",
    serviceFn: ({
      startDate,
      endDate,
      jobType,
    }: {
      startDate?: string;
      endDate?: string;
      jobType?: string;
    }) =>
      reportService.employeeMonthlyWiseReport({ startDate, endDate, jobType }),
  },

  {
    name: "employeeReimbursementReportList",
    type: "query",
    serviceFn: ({
      employeeId,
      endDate,
      page,
      reimbursementType,
      size,
      startDate,
    }: {
      page?: number;
      size?: number;
      startDate?: string;
      endDate?: string;
      reimbursementType?: string;
      employeeId?: string;
    }) =>
      reportService.reimbursmentReport({
        page,
        size,
        startDate,
        endDate,
        reimbursementType,
        employeeId,
      }),
  },

  {
    name: "employeeMasterReportList",
    type: "query",
    serviceFn: ({
      page,
      size,
      name,
      status,
      doj,
      dojEndDate,
      dojStartDate,
      dob,
      dobEndDate,
      dobStartDate,
      departmentId,
      jobType,
      centerId,
      anniversary,
      anniversaryStartDate,
      anniversaryEndDate,
      exit,
      exitEndDate,
      exitStartDate,
    }: {
      page?: number;
      size?: number;
      name?: string;
      status?: number;
      doj?: boolean;
      dojStartDate?: string;
      dojEndDate?: string;
      dob?: boolean;
      dobStartDate?: string;
      dobEndDate?: string;
      jobType?: string;
      departmentId?: number;
      centerId?: number;
      anniversary?: boolean;
      anniversaryStartDate?: string;
      anniversaryEndDate?: string;
      exit?: boolean;
      exitStartDate?: string;
      exitEndDate?: string;
    }) =>
      hrService.employeeMasterData({
        page,
        size,
        name,
        status,
        doj,
        dojEndDate,
        dojStartDate,
        dob,
        dobStartDate,
        dobEndDate,
        jobType,
        departmentId,
        centerId,
        anniversary,
        anniversaryEndDate,
        anniversaryStartDate,
        exit,
        exitEndDate,
        exitStartDate,
      }),
  },
] as const;

export const reportZoneApi = rootApi.injectEndpoints({
  endpoints: (builder) => makeEndpoints(builder, reportZoneEndpoints),
});

export const {
  useEmployeeMasterReportListQuery,
  useEmployeeSalaryReportListQuery,
  useEmployeeLeaveReportListQuery,
  useEmployeeAttendanceCompoffSummaryListQuery,
  useEmployeeMonthlyWiseReportListQuery,
  useEmployeesConveyanceReportListQuery,
  useEmployeeReimbursementReportListQuery,
  useLazyEmployeeLeaveReportListQuery,
  useLazyEmployeeMasterReportListQuery,
  useLazyEmployeesConveyanceReportListQuery,
  useLazyEmployeeMonthlyWiseReportListQuery,
  useLazyEmployeeReimbursementReportListQuery,
} = reportZoneApi;
